import React, {useEffect} from 'react';
import { useFetchLegend } from '../hooks/useFetchLegend';

const LegendContent = ({ geoserverUrl, layerName, data, setLegendData, setBbox }) => {    

    const legendData = useFetchLegend(geoserverUrl, layerName, data.style);

    useEffect( () => {
        setLegendData(legendData)
    }, [legendData])    

    if (legendData !== '') {        
        return (          
            <div className='legend-content'>
            {legendData.map((rule, index) => (
                <div key={index} className="legend-item">
                <div className="color-box" style={{ backgroundColor: rule.symbolizers[0].Polygon.fill }}></div>
                <span>{rule.title}</span>
                </div>
            ))}
            </div> 
        );
    }
};

export default LegendContent;